
<a href="" class="btn d-flex align-items-center">
    <!-- <i v-if="active" class="check-square fa fa-2x fa-check-square"></i>
    <i v-else class="square-o fa fa-2x fa-square-o"></i> -->
    <i v-if="active" class="fa fa-lg fa-check-square active"></i>
    <i v-else class="fa fa-lg fa-check-square "></i>
    {{ text }}
</a>
